import { Button, Card, CardBody, Flex } from '@chakra-ui/react'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { useNavigate } from 'react-router-dom'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { PageToolbar } from '@/containers/PageToolbar'
import { Pagination } from '@/containers/Pagination'
import { PpzAuthorizationList } from '@/containers/ppz-authorization/PpzAuthorizationList'
import { PpzAuthorizationListFilter } from '@/containers/ppz-authorization/PpzAuthorizationListFilter'
import { ppzAuthorizationListContext } from '@/context/PpzAuthorizationListContext'
import type { PpzAuthorizationPagedQuery } from '@/dtos'
import { PpzAuthorizationListType } from '@/dtos/PpzAuthorization/PpzAuthorizationListType'
import { useGetAll } from '@/hooks/usePpzAuthorization'
import { Add } from '@/icons'
import { PageWrapper } from '@/layouts/components/PageWrapper'

const defaultPageSize = 15
export const PpzAuthorizationListPage = () => {
  const [filter, setFilter] =
    useSearchParamsStatePersistance<PpzAuthorizationPagedQuery>(
      {
        name: '',
        pageIndex: 1,
        listType: PpzAuthorizationListType.All,
        pageSize: defaultPageSize,
      },
      []
    )
  const navigate = useNavigate()

  const { data, isLoading: isLoading, refetch } = useGetAll(filter)

  return (
    <PageWrapper
      header={<DashboardHeader title="Autorizace PPZ" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 4,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      <ppzAuthorizationListContext.Provider
        value={{
          loading: isLoading,
          totalCount: data?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? defaultPageSize,
          filter: filter,
          setCurrentPage: (p: number) => setFilter({ ...filter, pageIndex: p }),
          setPageSize: () => { },
          updateFilter: setFilter,
          reload: refetch,
        }}
      >
        <PageToolbar
          rightElements={
            <Flex sx={{ gap: 4 }}>
              <Button
                colorScheme="primary"
                onClick={() => navigate('/ppzAuthorization/create')}
              >
                <Add />
                Vytvořit novou autorizaci PPZ
              </Button>
            </Flex>
          }
        />

        <Card>
          <CardBody>
            <PpzAuthorizationListFilter p={6} />
            <PpzAuthorizationList ppzAuthorizations={data?.items ?? []} />
            <Pagination context={ppzAuthorizationListContext} />
          </CardBody>
        </Card>
      </ppzAuthorizationListContext.Provider>
    </PageWrapper>
  )
}